import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import apiClient from '@/lib/api';
import { createApplication } from '@/lib/recruitmentApi';
export default function StartRecruitmentModal({
  candidateId,
  needId,
  onClose
}) {
  const navigate = useNavigate();
  const [choices, setChoices] = useState([]);
  const [selected, setSelected] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    apiClient.get(needId ? '/recruitment/candidates' : '/recruitment/needs').then(r => setChoices(r.data.filter(item => !item.status || ['open', 'in_progress', 'active'].includes(item.status)))).catch(() => setError('La liste n’a pas pu être chargée.'));
  }, [needId]);
  const start = async e => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const app = await createApplication({
        candidate_id: candidateId || selected,
        need_id: needId || selected || null
      });
      navigate(`/admin/recrutement/pipeline?application_id=${app._id || app.id}`);
      onClose();
    } catch (err) {
      setError(typeof err?.response?.data?.detail === 'string' ? err.response.data.detail : 'Le recrutement n’a pas pu démarrer.');
    } finally {
      setBusy(false);
    }
  };
  return <Dialog open onOpenChange={open => {
    if (!open && !busy) onClose();
  }}><DialogContent className="bg-slate-950 text-white border-white/20 w-[calc(100%_-_2rem)]"><DialogTitle>{needId ? 'Positionner un candidat' : 'Démarrer un recrutement'}</DialogTitle><DialogDescription>{needId ? 'Choisissez le candidat à positionner.' : 'Choisissez un besoin client ou démarrez un parcours vivier.'}</DialogDescription>
    <form onSubmit={start} className="space-y-4"><label className="block text-sm">{needId ? 'Candidat' : 'Besoin client (facultatif)'}<select className="block mt-2 w-full min-h-11 rounded-lg bg-slate-900 border border-white/20 px-3" value={selected} onChange={e => setSelected(e.target.value)} required={!!needId}><option value="">{needId ? 'Choisir un candidat' : 'Sans besoin client — parcours vivier'}</option>{choices.map(item => <option key={item._id} value={item._id}>{needId ? `${item.first_name} ${item.last_name}` : item.title}</option>)}</select></label>{error && <p role="alert" className="text-rose-300">{error}</p>}<div className="flex justify-end gap-3"><button type="button" className="min-h-11 px-4" onClick={onClose}>Annuler</button><button disabled={busy || !!needId && !selected} className="min-h-11 bg-blue-600 rounded-lg px-4 disabled:opacity-50">{busy ? 'Démarrage…' : needId ? 'Positionner le candidat' : 'Démarrer le recrutement'}</button></div></form>
  </DialogContent></Dialog>;
}
